// Centralised site data: nav links, services, products, projects, etc.
import {
    Zap, Battery, Construction, Activity, Cable, Sun, Truck, Building2,
    HeartPulse, Landmark, Cpu, Wallet, ShieldCheck, BarChart3, Users,
    GraduationCap, Briefcase, BatteryCharging, Flag, Anchor, Plane
} from "lucide-react";

export const COMPANY = {
    name: "M-Class EV Charging",
    tagline: "Go electric, go everywhere.",
    phone: "940-453-5414",
    email: "oross@mclassevcharging.com",
    city: "5 Cowboys Way, Suite 300, Frisco, TX 75034",
    cityShort: "Frisco, TX",
    founder: "Omari Ross",
    coo: "Robert Ross",
};

export const NAV = [
    { label: "Solutions", to: "/services", children: [
        { label: "DC Fast Charging", to: "/services#dc-fast" },
        { label: "Megawatt Charging (MCS)", to: "/services#mcs" },
        { label: "Level 2 Charging", to: "/services#level-2" },
        { label: "Site Development", to: "/services#site-development" },
        { label: "Operations & Maintenance", to: "/services#operations" },
        { label: "Marine Charging", to: "/services#marine" },
        { label: "Aviation Charging", to: "/services#aviation" },
        { label: "Commercial Property", to: "/commercial" },
        { label: "Fleet Charging", to: "/fleet" },
    ]},
    { label: "Products", to: "/products" },
    { label: "Site Host", to: "/site-host" },
    { label: "Grants", to: "/grants" },
    { label: "Projects", to: "/projects" },
    { label: "Technology", to: "/technology" },
    { label: "Sustainability", to: "/sustainability" },
    { label: "Company", to: "/about", children: [
        { label: "About", to: "/about" },
        { label: "Investors", to: "/investors" },
        { label: "Careers", to: "/careers" },
        { label: "News & Insights", to: "/blog" },
    ]},
    { label: "Contact", to: "/contact" },
];

export const IMAGES = {
    wallboxStation: "https://customer-assets.emergentagent.com/job_charge-everywhere-2/artifacts/f18b15ec_image.png",
    heroFastCharging: "https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxlbGVjdHJpYyUyMHZlaGljbGUlMjBjaGFyZ2luZyUyMHN0YXRpb258ZW58MHx8fHwxNzgyNjcwODkwfDA&ixlib=rb-4.1.0&q=85",
    solarCanopy: "https://images.unsplash.com/photo-1491677533189-49af044391ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsJTIwY2Fub3B5JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MjY3MDg5MHww&ixlib=rb-4.1.0&q=85",
    commercial: "https://images.unsplash.com/photo-1585349781000-d086e113b2a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBleHRlcmlvciUyMG5pZ2h0fGVufDB8fHx8MTc4MjY3MDg5MHww&ixlib=rb-4.1.0&q=85",
    fleet: "https://images.unsplash.com/photo-1732193933813-4da17265a36c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxlbGVjdHJpYyUyMGZsZWV0JTIwdmFuJTIwY2FyZ298ZW58MHx8fHwxNzgyNjcwODkwfDA&ixlib=rb-4.1.0&q=85",
    founder: "https://images.pexels.com/photos/28426637/pexels-photo-28426637.jpeg",
    celina: "https://images.pexels.com/photos/4678065/pexels-photo-4678065.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    chargingPark: "https://images.unsplash.com/photo-1696582155321-ed5b5d4d72d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    evDriving: "https://images.unsplash.com/photo-1617704548623-340376564e68?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cityNight: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    blueprint: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    teamCollab: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    apartment: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    truckCharging: "https://images.unsplash.com/photo-1697554330320-3cf7e21b9cfe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    marina: "https://images.unsplash.com/photo-1568430328012-21ed450453ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    airport: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const SERVICES = [
    {
        id: "dc-fast",
        icon: Zap,
        title: "DC Fast Charging",
        kicker: "150kW – 400kW",
        copy: "High-throughput corridors, fleet depots, and public charging hubs engineered for utility-grade reliability and revenue performance.",
        bullets: ["150kW to 400kW charging", "Battery backup systems", "Solar canopy integration", "Utility & transformer coordination", "Demand management"],
    },
    {
        id: "mcs",
        icon: BatteryCharging,
        title: "Megawatt Charging (MCS)",
        kicker: "1MW+ for Class 8 & Heavy Equipment",
        copy: "MCS-standard megawatt charging infrastructure engineered for semi-trucks, transit buses, and large-frame off-highway equipment with battery and grid integration.",
        bullets: ["1MW+ peak charging", "Class 8 truck depots", "Transit & shuttle fleets", "Mining & off-highway equipment", "Battery storage & grid integration", "MCS connector standard"],
    },
    {
        id: "level-2",
        icon: Battery,
        title: "Level 2 Charging",
        kicker: "Multifamily, Workplace, Retail",
        copy: "Smart, networked Level 2 solutions for the places people park the longest — purpose-built for tenants, employees, guests, and residents.",
        bullets: ["Apartments & multifamily", "Hotels & hospitality", "Office & workplace", "Municipal facilities", "Retail destinations"],
    },
    {
        id: "site-development",
        icon: Construction,
        title: "Site Development",
        kicker: "End-to-End Delivery",
        copy: "From site selection through commissioning — we navigate the entire infrastructure lifecycle so property owners don't have to.",
        bullets: ["Site selection & feasibility", "Utility coordination", "Civil engineering", "Electrical engineering", "Permitting & inspection", "Construction management"],
    },
    {
        id: "operations",
        icon: Activity,
        title: "Operations & Maintenance",
        kicker: "24/7 Network Operations",
        copy: "Ongoing operations that protect uptime, drive utilization, and turn charging assets into long-term revenue streams.",
        bullets: ["Remote monitoring & diagnostics", "Network management", "Preventative maintenance", "Revenue & utilization reporting", "Firmware & software updates"],
    },
    {
        id: "marine",
        icon: Anchor,
        title: "Marine Charging",
        kicker: "Ports, Marinas & Vessels",
        copy: "Shore-power and high-power DC charging for electric vessels, harbor-front fleets, and marina infrastructure — engineered for waterfront environments.",
        bullets: ["Shore-power & high-voltage DC", "Electric vessel & ferry charging", "Marina & yacht-club deployment", "Port authority & cruise terminal", "Saltwater-rated infrastructure", "Cold-ironing for docked ships"],
    },
    {
        id: "aviation",
        icon: Plane,
        title: "Aviation Charging",
        kicker: "Airports, eVTOL & Ground Support",
        copy: "Charging infrastructure for electric aircraft (eVTOL/eSTOL), airport ground support equipment, and on-airport fleet electrification.",
        bullets: ["eVTOL & eSTOL vertiports", "Ground Support Equipment (GSE)", "Pushback tugs & belt loaders", "Airport authority partnerships", "FAA-aligned site design", "Megawatt-class fast charging"],
    },
];

export const PRODUCTS = [
    { name: "180 kW Dual-Port DC Fast Charger", category: "DC Fast Charger", specs: ["180 kW peak output", "Shared power architecture", "Dual CCS1 charging ports", "OCPP 1.6 / 2.0.1"], image: IMAGES.wallboxStation },
    { name: "Modular Satellite DC Fast System", category: "Modular DC Fast", specs: ["Modular satellite topology", "Dynamic load balancing", "Fleet-optimized depot design", "Up to 600 kW per power unit"], image: IMAGES.fleet },
    { name: "Utility-Grade Commercial DC Fast Charger", category: "Commercial DC Fast", specs: ["Utility-grade reliability", "Multi-standard outputs (CCS / NACS)", "Highway corridor ready", "Remote management"], image: IMAGES.chargingPark },
    { name: "Networked Commercial Level 2 Charger", category: "Commercial Level 2", specs: ["Up to 22 kW (three-phase)", "OCPP networked", "Compact wall-mount", "Multifamily & workplace ready"], image: IMAGES.apartment },
];

export const PROJECTS = [
    { id: "plano", title: "Plano Charging Hub", location: "Plano, TX", status: "In Development", image: IMAGES.wallboxStation,
      stats: [{ k: "8", v: "DC Fast Ports" }, { k: "150kWh+", v: "Per Port" }, { k: "Solar", v: "Canopy" }, { k: "BESS", v: "Storage Ready" }],
      desc: "Flagship North-Texas hub combining 8 Wallbox high-power DC fast ports with solar canopy and battery-storage-ready architecture. Truck charging expansion planned." },
    { id: "healthcare", title: "Healthcare Charging Program", location: "Multi-Site, TX", status: "Partner Sites", image: IMAGES.commercial,
      stats: [{ k: "Level 2", v: "+ DC Fast" }, { k: "24/7", v: "Patient Access" }],
      desc: "Partner locations serving hospitals and outpatient campuses with reliable charging for patients, staff, and emergency fleet vehicles." },
    { id: "municipal", title: "Municipal P3 Initiatives", location: "Texas Municipalities", status: "Active P3", image: IMAGES.cityNight,
      stats: [{ k: "P3", v: "Model" }, { k: "NEVI", v: "Eligible" }, { k: "ADA", v: "Compliant" }, { k: "American", v: "Vendors" }],
      desc: "Public-private partnership program enabling municipalities to deploy charging without upfront capital while maintaining community access and equity." },
];

export const GRANT_PROGRAMS = [
    { name: "Texas NEVI Program", icon: Cable, blurb: "$408M federal allocation for Texas — corridor-ready DC fast charging along designated AFCs." },
    { name: "TCEQ Alternative Fueling", icon: Sun, blurb: "Texas Commission on Environmental Quality grants for fueling and charging infrastructure." },
    { name: "NCTCOG Transportation Funding", icon: Truck, blurb: "North Central Texas Council of Governments — regional clean transportation funding." },
    { name: "Federal Infrastructure Programs", icon: Landmark, blurb: "CFI, RAISE, USDA Rural, DOE programs — full federal grant portfolio support." },
];

export const COMMERCIAL_TARGETS = [
    { icon: Building2, label: "Shopping Centers" },
    { icon: Building2, label: "Hotels & Hospitality" },
    { icon: Building2, label: "Mixed-Use Developments" },
    { icon: Building2, label: "Office Buildings" },
    { icon: HeartPulse, label: "Healthcare Facilities" },
    { icon: Landmark, label: "Municipal Properties" },
];

export const FLEET_TARGETS = [
    { label: "Delivery Fleets" }, { label: "Municipal Fleets" }, { label: "School Districts" },
    { label: "Logistics Providers" }, { label: "Transit Agencies" }, { label: "Last-Mile Operators" },
];

export const TECH_FEATURES = [
    { icon: Cpu, title: "OCPP Compliant", body: "Open Charge Point Protocol 1.6 & 2.0.1 — vendor-neutral, future-proof networks." },
    { icon: Activity, title: "Remote Monitoring", body: "24/7 real-time diagnostics with automated alerts and SLA-grade uptime tracking." },
    { icon: Wallet, title: "Multi-Payment + Cash Kiosk", body: "Apple Pay, Google Pay, RFID, WEX fleet cards, plug-and-charge — plus on-site cash kiosks that convert cash into stored-value RFID cards for unbanked drivers." },
    { icon: BarChart3, title: "Revenue Analytics", body: "Session-level reporting, utilization heat maps, dynamic pricing, and host portals." },
    { icon: ShieldCheck, title: "American Vendors", body: "Equipment sourced from American manufacturers — aligned with federal procurement and Buy-American program eligibility." },
    { icon: Cable, title: "Smart Load Mgmt", body: "Dynamic load balancing, peak shaving, and demand response across distributed sites." },
];

export const BLOG_POSTS = [
    { slug: "nevi-texas-2025-update", title: "Texas NEVI Round 2: What Site Hosts Need to Know", category: "Grant Updates", date: "Dec 18, 2025", excerpt: "The latest Texas NEVI Round 2 awards reshape the corridor map. Here's how property owners can position for the next solicitation.", image: IMAGES.chargingPark },
    { slug: "fleet-electrification-roi", title: "The True ROI of Fleet Electrification in Texas", category: "Fleet Electrification", date: "Dec 9, 2025", excerpt: "Beyond fuel savings — total cost of ownership analysis for medium-duty delivery fleets across DFW and Houston.", image: IMAGES.fleet },
    { slug: "megawatt-charging-truck", title: "Megawatt Charging: Designing for Class 8 Trucking", category: "Charging Technology", date: "Nov 27, 2025", excerpt: "MCS standards are landing. What megawatt-class deployment looks like for North-Texas freight corridors.", image: IMAGES.truckCharging },
    { slug: "multifamily-level2-playbook", title: "The Multifamily Level 2 Playbook", category: "EV Industry News", date: "Nov 14, 2025", excerpt: "How apartment owners are turning EV charging from amenity into NOI driver — without the capex headache.", image: IMAGES.apartment },
    { slug: "tceq-grant-deadlines", title: "TCEQ AFFP Application Window Opens", category: "Grant Updates", date: "Nov 02, 2025", excerpt: "Deadlines, eligibility, and pre-application coordination strategy for the Texas Commission on Environmental Quality program.", image: IMAGES.blueprint },
    { slug: "veteran-owned-infrastructure", title: "Why Veteran-Owned Infrastructure Matters in Procurement", category: "Texas Infrastructure", date: "Oct 21, 2025", excerpt: "SDVOSB, HUB and veteran preference programs create real procurement advantages — for the agencies who use them well.", image: IMAGES.teamCollab },
];

export const CAREERS = [
    { title: "EV Charging Project Manager", location: "Frisco, TX", type: "Full-time", team: "Operations" },
    { title: "Electrical Engineer — EV Infrastructure", location: "Texas (Hybrid)", type: "Full-time", team: "Engineering" },
    { title: "Site Acquisition Manager", location: "Texas (Remote-eligible)", type: "Full-time", team: "Development" },
    { title: "Grant & Compliance Analyst", location: "Frisco, TX", type: "Full-time", team: "Programs" },
    { title: "Field Service Technician", location: "DFW Metroplex", type: "Full-time", team: "Operations" },
    { title: "EV Infrastructure Internship", location: "Celina, TX", type: "Internship", team: "Programs" },
];

export const ICONS = { Zap, Battery, Construction, Activity, Cable, Sun, Truck, Building2, HeartPulse, Landmark, Cpu, Wallet, ShieldCheck, BarChart3, Users, GraduationCap, Briefcase };
